import { motion } from "framer-motion";
import { Stethoscope, Award, BellRing, Dog } from "lucide-react";

const chapters = [
  {
    n: "01",
    icon: Award,
    title: "Authentic Breed, Papers Guaranteed",
    body: "Every puppy is KCI Registered and Government Certified — full documentation handed over, no shortcuts.",
    span: "md:col-span-7",
  },
  {
    n: "02",
    icon: Stethoscope,
    title: "Lifetime Medical Support",
    body: "A qualified BVSc veterinarian stands behind every dog we place, for as long as they're with you.",
    span: "md:col-span-5",
  },
  {
    n: "03",
    icon: BellRing,
    title: "Lifetime Vaccination & Deworming Reminders",
    body: "We don't disappear after the sale. Expect timely reminders for every vaccination & deworming cycle, for life.",
    span: "md:col-span-5",
  },
  {
    n: "04",
    icon: Dog,
    title: "Currently Breeding: Golden Retrievers",
    body: "Our current focus is raising authentic, well-socialised Golden Retriever puppies with love and discipline.",
    span: "md:col-span-7",
  },
];

export const Manifesto = () => {
  return (
    <section id="about" className="py-24 md:py-32 px-6 md:px-10 max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-16 max-w-2xl"
      >
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-[#D97736] mb-4">Our Promise</p>
        <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-[#0F2520]">
          Not just a breeder. A lifetime commitment.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className={`${c.span} col-span-1 bg-white rounded-[2rem] p-8 md:p-10 border border-[#DCD7CE] hover:shadow-xl transition-shadow duration-300`}
          >
            <div className="flex items-start justify-between mb-8">
              <span className="font-display text-5xl font-bold text-[#EFECE5]">{c.n}</span>
              <c.icon className="w-8 h-8 text-[#D97736]" />
            </div>
            <h3 className="font-display text-2xl md:text-3xl font-semibold mb-3 text-[#0F2520]">{c.title}</h3>
            <p className="text-base font-light text-[#0F2520]/70 leading-relaxed">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
